<script setup>
import { computed, ref } from 'vue';
import { URL_HOME } from '@elements/tools/routes/routes';
import Icon from '@components/Icon.vue';
import Tag from '@components/Tag.vue';
import { useUserProfile } from '@organisms/ubiq-administration/composables/useUserProfile';
import { CLOSE_LOGIN_MODAL, CLOSE_MOBILE_PANEL, SHOW_LOGIN_MODAL } from '@molecules/modal-constants';
import eventBus from '@elements/tools/event-bus';
import { trans } from '@elements/translation';
import IconList from '@icons/ph_list.svg';
import { useNavbarMenu } from '../useNavbarMenu';
import MobileVerticalMenu from './MobileVerticalMenu.vue';

const cdnUrl = window.CDN_URL;
const notifications = computed(() => window.USER_NOTIFICATIONS);
const openedLogin = ref(false);

const { stickyMenuItems } = useNavbarMenu();

const { hasKYCActive } = useUserProfile();

const isPanelOpen = ref(false);

eventBus.addEventListener(CLOSE_LOGIN_MODAL, () => {
  openedLogin.value = false;
});

eventBus.addEventListener(CLOSE_MOBILE_PANEL, () => {
  isPanelOpen.value = false;
});

const handleMenuClick = (menuItem) => {
  if (openedLogin.value) {
    eventBus.dispatchEvent(new CustomEvent(CLOSE_LOGIN_MODAL));
  }

  if (menuItem.icon === IconList) {
    isPanelOpen.value = !isPanelOpen.value;
    document.body.classList.toggle('no-scroll');
    return;
  }

  if (menuItem.event) {
    if (menuItem.event === SHOW_LOGIN_MODAL) {
      openedLogin.value = true;
    }

    eventBus.dispatchEvent(new CustomEvent(menuItem.event));
    return;
  }

  const currentPath = window.location.pathname;
  if (menuItem.link !== currentPath) {
    window.location = menuItem.link;
  }
};

const currentMenuName = computed(() => {
  if (openedLogin.value) {
    return trans('user_menu.login');
  }

  if (isPanelOpen.value) {
    return trans('user_menu.plus');
  }

  const currentPath = window.location.pathname;

  const currentMenuItem = stickyMenuItems.value.find((item) => {
    if (item.similarLinks) {
      return item.similarLinks.some((similarLink) => currentPath.startsWith(similarLink)) || (item.link && currentPath === item.link);
    }

    return item.link && currentPath === item.link;
  });

  return currentMenuItem?.name || '';
});
</script>

<template>
  <div>
    <nav class="nav-mobile nav-user-mobile">
      <div
        v-for="menuItem in stickyMenuItems"
        :key="menuItem.name"
        class="nav-mobile__item"
        :class="[ { 'nav-mobile--current': currentMenuName === menuItem.name }, menuItem.iconName ]"
        @click="handleMenuClick(menuItem)"
      >
        <span
          v-if="menuItem.notification && notifications[menuItem.notification] > 0"
          class="sticky-mobile--icon-pin"
        />
        <Tag
          v-if="menuItem.isNew && !hasKYCActive"
          text-color="purple"
          background-color="purple-lighter"
          class="nav-mobile__new-tag"
        >
          {{ trans('gestion.tag.new') }}
        </Tag>
        <Icon
          :svg="menuItem.icon"
          :custom-class="menuItem.iconName"
          height="24"
          width="24"
          fill="gray-darker"
        />
        <span
          class="nav-mobile-label"
        >
          {{ menuItem.name }}
        </span>
      </div>
    </nav>

    <div v-if="isPanelOpen" class="sliding-side-bar">
      <div class="sliding-side-bar__header">
        <a :href="URL_HOME">
          <img :src="`${cdnUrl}/images/logo.svg`" width="75" height="40">
        </a>
        <button class="sliding-header__close" @click="isPanelOpen = false" />
      </div>

      <MobileVerticalMenu class="sliding-side-bar__content" />
    </div>
  </div>
</template>
